// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__LvaAz","content":"LayoutSettings_content__UAG5T"};